const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.349 6.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.87 174.483c-.464-.652-1.668-2.123-3.079-2.123s-2.614 1.47-3.078 2.123a.53.53 0 0 0 0 .609c.464.651 1.667 2.122 3.078 2.122s2.615-1.47 3.078-2.122a.53.53 0 0 0 0-.61m-3.079 1.657a1.353 1.353 0 1 1 0-2.706 1.353 1.353 0 0 1 0 2.706",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-58.615 -171.614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.791 175.935a1.148 1.148 0 1 0 0-2.297 1.148 1.148 0 0 0 0 2.297",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-58.615 -171.614)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.94cbf8924c5bb7b8e09814a88dcf79fe.svg";
export { ForwardRef as ReactComponent };